var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "10 12 10.001 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.15 16.463a.465.465 0 0 0 0 .683l.716.684a.52.52 0 0 0 .715 0l3.405-3.295 3.434 3.322a.52.52 0 0 0 .716 0l.716-.683a.47.47 0 0 0 0-.684l-4.507-4.349a.526.526 0 0 0-.717 0z"
})));
export default SvgCaretUp;